<template>
  <b-container fluid="md">
    <LoadingOverlay v-if="isLoading" />
    <b-container
      v-else
      fluid="md"
    >
      <b-row>
        <b-col cols="12">
          <h1>{{ organization.name }} Details</h1>
        </b-col>
      </b-row>
    </b-container>
    <hr>
    <b-container class="p-md-4">
      <b-row
        cols="1"
        cols-lg="2"
      >
        <b-col>
          <b-card class="mb-md-3 p-2">
            <b-row>
              <h3>{{ organization.name }} Info:</h3>
            </b-row>
            <b-row>
              <b-form
                @submit.prevent="updateOrganizationInfo"
              >
                <b-form-group
                  label="Name: "
                  label-for="organizationNme"
                  class="pr-2"
                >
                  <b-input
                    v-model="organizationName"
                    name="organizationName"
                    size="sm"
                    @input="setNameChanged"
                  />
                </b-form-group>
                <b-form-group label="Hours of operation: ">
                  <b-row
                    class="d-flex flex-column flex-lg-row ml-lg-4 mr-lg-4 mb-lg-4"
                    cols="1"
                    cols-lg="12"
                  >
                    <b-col
                      cols="1"
                      class="d-flex align-items-center"
                    >
                      Open
                    </b-col>
                    <b-col cols="5">
                      <b-time
                        v-model="openTime"
                        name="openingTimeSelector"
                        size="sm"
                        minutes-step="15"
                        hide-header
                      />
                    </b-col>
                    <b-col
                      cols="1"
                      class="d-flex align-items-center"
                    >
                      Close
                    </b-col>
                    <b-col cols="5">
                      <b-time
                        v-model="closeTime"
                        name="openingTimeSelector"
                        size="sm"
                        minutes-step="15"
                        hide-header
                      />
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-button
                  size="sm"
                  type="submit"
                  variant="success"
                >
                  <b-spinner v-if="updatePending">
                    Loading
                  </b-spinner>
                  <span v-else>Update Info</span>
                </b-button>
              </b-form>
            </b-row>
          </b-card>
        </b-col>
        <b-col>
          <b-card>
            <b-row>
              <b-col cols="7">
                <b-row style="padding-left: 1.2rem">
                  <h3>Locations:</h3>
                </b-row>
              </b-col>
              <b-col>
                <b-row
                  align-h="end"
                  style="padding-right: 25px;"
                >
                  <b-button
                    size="sm"
                    variant="success"
                    class="mt-n2 mr-n2"
                    @click="toggleManageLocationsOverlay"
                  >
                    Manage Locations
                  </b-button>
                </b-row>
              </b-col>
            </b-row>
            <b-list-group>
              <b-list-group-item
                v-for="location in locations"
                :key="location.id"
                :active="!!location.isDefault"
                button
                active-class="active"
                @click="setDefaultCourt(location.id)"
              >
                {{ location.address }}
              </b-list-group-item>
            </b-list-group>
            <div
              class="text-sm-right align-self-end w-100 pt-1"
              style="font-size: small"
            >
              Click to set location as default
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <modal-overlay
      ref="manageLocationsModal"
      modal-id="manageLocationsModal"
      size="lg"
      :modal-show="showManageLocations"
      title="Manage Locations"
      :hide-footer="true"
      @hide="toggleManageLocationsOverlay"
    >
      <div class="d-flex">
        <b-list-group class="w-100">
          <b-list-group-item
            v-for="location in locations"
            :key="location.id"
            :active="!!location.isDefault"
            active-class="active"
          >
            <b-row>
              <b-col cols="10">
                {{ location.address }}
              </b-col>
              <b-col
                cols="2"
                style="display: flex; flex-direction: column"
              >
                <b-icon-trash-fill
                  v-if="!location.isDefault"
                  scale="1.5"
                  style="align-self: end; cursor: pointer"
                  @click="deleteLocation(location.id)"
                />
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item>
            <b-form
              inline
              class="mb-n1"
            >
              <b-form-row class="w-100">
                <b-col class="mt-2">
                  <b-input
                    v-model="newLocationAddress"
                    type="text"
                    placeholder="Address"
                    size="sm"
                  />
                </b-col>
                <b-col class="d-flex flex-column">
                  <b-button
                    size="sm"
                    variant="success"
                    style="align-self: end"
                    @click="addLocation"
                  >
                    Add Location
                  </b-button>
                </b-col>
              </b-form-row>
            </b-form>
          </b-list-group-item>
        </b-list-group>
      </div>
    </modal-overlay>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import filter from 'lodash/filter';
import find from 'lodash/find';
import LoadingOverlay from '../../common/LoadingOverlay';
import ModalOverlay from '../../common/ModalOverlay';

export default {
  name: 'Settings',
  components: {
    LoadingOverlay,
    ModalOverlay,
  },
  data: () => ({
    closeTime: '',
    isLoading: true,
    locations: [],
    nameUpdated: false,
    newLocationAddress: '',
    openTime:'',
    organizationName: '',
    showManageLocations: false,
    updatePending: false,
  }),
  computed: {
    ...mapState({
      organization: state => state.organization,
    }),
  },
  created() {
    this.organizationName = this.organization.name;
    this.openTime = this.organization.openTime;
    this.closeTime = this.organization.closeTime;
    this.getOrganizationDetails();
  },
  methods: {
    
    async addLocation() {
      try {
        const {data: createdLocation } = await axios.post(`/api/${this.organization.slug}/location`, {
          address: this.newLocationAddress,
          name: this.newLocationAddress,
        });
        this.locations.push(createdLocation);
      } catch (e) {
        //TODO Handle error
      }
    },
    
    async deleteLocation (locationId) {
      console.log('Deleting location: ' + locationId);
      try {
        await axios.delete(`/api/${ this.organization.slug }/location/${ locationId }`);
        this.locations = filter(this.locations, location => location.id !== locationId);
      } catch (e) {
        //TODO Handle error
      }

    },

    async getOrganizationDetails () {
      const { data: { locations } } = await axios.get(`/api/${this.organization.slug}/location`);
      this.locations = locations;
      this.isLoading = false;
    },
    
    async setDefaultCourt(newDefaultId) {
      try {
        const currentDefaultLocation = find(this.locations, (location) => !!location.isDefault);
        const newDefault = find(this.locations, (location) => location.id === newDefaultId);
        newDefault.updating = true;
        await axios.put(`/api/${ this.organization.slug }/location/default`, {
          currentDefaultId: currentDefaultLocation,
          newDefaultId,
        });
        currentDefaultLocation.isDefault = 0;
        newDefault.isDefault = 1;
        newDefault.updating = false;
      } catch (e) {
        //TODO Handle error
      }
    },

    setNameChanged(){ this.nameUpdated = this.organization.name !== this.organizationName; },
    
    toggleManageLocationsOverlay() {
      const { manageLocationsModal } = this.$refs;

      if (this.showManageLocations)
        manageLocationsModal.hide();
      else
        manageLocationsModal.show();

      this.showManageLocations = !this.showManageLocations;
    },

    async updateOrganizationInfo() {
      try {
        this.updatePending = true;
        await axios.post(`/api/${this.organization.slug}/info`, {
          closeTime: this.closeTime,
          name: this.organizationName.trim(),
          openTime: this.openTime,
        });

        this.organization.name = this.organizationName;
        this.organization.openTime = this.openTime;
        this.organization.closeTime = this.closeTime;
        this.updatePending = false;
      } catch (e) {
        //TODO Handle error
      }
    },

  },
};
</script>

<style scoped>
  .active {
    z-index: 2;
    color: #fff;
    background-color: #20986d;
    border-color: #20986d;
  }
</style>